import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const NewCEOAssignmentNotification = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl ? 'تعييم مديراً تنفيذياً جديداً' : 'New ceo has been assigned'
      }
    />
  )
}

export default NewCEOAssignmentNotification
